module.exports = __webpack_public_path__ + "img/charitybounce.2c61312.png";